export default __webpack_public_path__ + "static/media/red-1.28895c35.png";